import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import Home from "@/pages/Home";
import ArticleDetail from "@/pages/ArticleDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ArticleEditor from "@/pages/admin/ArticleEditor";
import AdminConsents from "@/pages/admin/AdminConsents";
import AdminDeals from "@/pages/admin/AdminDeals";
import Cgu from "@/pages/legal/Cgu";
import Cgv from "@/pages/legal/Cgv";
import Confidentialite from "@/pages/legal/Confidentialite";
import ConsentManage from "@/pages/legal/ConsentManage";
import CityPage from "@/pages/CityPage";
import ReviewPage from "@/pages/ReviewPage";
import ComparatorHub from "@/pages/comparator/ComparatorHub";
import ComparatorPage from "@/pages/comparator/ComparatorPage";
import OfferPage from "@/pages/OfferPage";
import SavingsPage from "@/pages/SavingsPage";
import CookieBanner from "@/components/CookieBanner";

function App() {
  // Default <title> lives in public/index.html; a parent useEffect here would run AFTER
  // child page effects on first load and overwrite city/offer/legal titles.
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/article/:slug" element={<ArticleDetail />} />
            <Route path="/courtier/:city" element={<CityPage />} />
            <Route path="/offre/:offer" element={<OfferPage />} />
            <Route path="/avis" element={<ReviewPage />} />
            <Route path="/simulateur-epargne" element={<SavingsPage />} />
            <Route path="/comparateur" element={<ComparatorHub />} />
            <Route path="/comparateur/:product" element={<ComparatorPage />} />
            <Route path="/comparateur/:product/offres" element={<ComparatorPage results />} />
            <Route path="/cgu" element={<Cgu />} />
            <Route path="/cgv" element={<Cgv />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/consentement" element={<ConsentManage />} />
            <Route path="/consentement/:token" element={<ConsentManage />} />
            <Route path="/admin/consentements" element={<ProtectedRoute><AdminConsents /></ProtectedRoute>} />
            <Route path="/admin/affaires" element={<ProtectedRoute><AdminDeals /></ProtectedRoute>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/articles/new" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
            <Route path="/admin/articles/:id" element={<ProtectedRoute><ArticleEditor /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </div>
  );
}

export default App;
